<div class="d-flex justify-content-center afri-bg-blue" style="height: 100vh; width: 100%; background-image: url('assets/bg.jpg'); background-repeat: no-repeat; background-size: cover;">

    <div class="col-6 mx-auto align-self-center">
        <div class="card">
            <div class="card-body">
                <form class="" #loginForm="ngForm" (ngSubmit)="login(loginForm.value)">
                    <div class="text-center mb-3">
                        <img src="../../../../../../assets/template2/logo.png" class="img-fluid" alt="" style="height: 80px;">

                    </div>
                    <h6 class="text-center"><b>Bienvenue sur Afrilink Backoffice</b></h6>
                    <p class="text-center">Connectez-vous pour continuer</p>
                    <div class="form-row">
            <div class="col-12">
            <div class="position-relative form-group">
            <label for="exampleEmail" class="">Email</label>
            <input name="email" id="exampleEmail" placeholder="Email ici..." type="email" class="form-control"  required ngModel>
            </div>
            </div>
            <div class="col-12">
            <div class="position-relative form-group">
            <label for="examplePassword" class="">Mot de passe</label> 
            <input name="password" id="examplePassword" placeholder="Mot de passe ici..." type="password" class="form-control"  required ngModel>
            </div>
            </div>
            </div>
            <div class="divider row"></div>
            <div class="d-flex align-items-center">
            <div class="ml-auto">
                <a routerLink="/forget-password" class="btn-lg btn btn-link">Mot de passe oublié</a>
                <button class="btn btn-primary btn-lg" [disabled]="loginForm.invalid || loading">Se connecter <app-loading [isVisible]="loading"></app-loading></button>
            </div>
            </div>
            </form>
            </div>
        </div>
    </div>
</div>
